import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { RemoteContent, Title } from '@jupi/ui'
import { useWeatherAirports } from '../../api/weather'
import { AirportWeatherCard } from '../../components/weather/AirportWeatherCard'

export default function WeatherPage() {
  const { t } = useTranslation()
  const { data: airports = [], isLoading, error } = useWeatherAirports()
  return (
    <Box>
      <Title label={t('weather.title')} />
      <RemoteContent isLoading={isLoading} error={error}>
        <Grid container spacing={2}>
          {airports.map((airport) => (
            <Grid key={airport.icao} size={{ xs: 12, lg: 6 }}>
              <AirportWeatherCard icao={airport.icao} />
            </Grid>
          ))}
        </Grid>
      </RemoteContent>
    </Box>
  )
}
